import { AxiosInstance } from "axios";
import { TokenHelper } from "../../types";

class TruStageApi {
  api: AxiosInstance;
  tokenHelper: TokenHelper;

  constructor(api: AxiosInstance, tokenHelper: TokenHelper) {
    this.api = api;
    this.tokenHelper = tokenHelper;
  }

  /**
   * Get TruStage products
   *
   * @param {object} options
   * @param {string} options.onboardingApplicationId Onboarding Application ID
   * @returns AxiosResponse
   */
  getProducts = ({
    onboardingApplicationId,
  }: {
    onboardingApplicationId: string;
  }) => {
    return this.api.get(
      `/onboarding-applications/${onboardingApplicationId}/trustage/products`,
      {
        headers: {
          Authorization: this.tokenHelper.formatAuthHeader(
            this.tokenHelper.getJwtToken()
          ),
        },
      }
    );
  };
}

export default TruStageApi;
